import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {
  AppBar,
  Toolbar,
  Typography,
  Container,
  Paper,
  Button
} from '@material-ui/core';
import CancelIcon from '@material-ui/icons/Cancel';
import cargoesLogo from '../../images/Cargoes.png';

const useStyles = makeStyles((theme) => ({
  root: {
    minHeight: '100vh',
    backgroundColor: '#f5f5f5'
  },
  appBar: {
    backgroundColor: theme.palette.primary.main
  },
  container: {
    padding: theme.spacing(4),
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: 'calc(100vh - 64px)'
  },
  paper: {
    padding: theme.spacing(4),
    textAlign: 'center',
    maxWidth: 600
  },
  icon: {
    fontSize: 64,
    color: theme.palette.error.main,
    marginBottom: theme.spacing(2)
  },
  button: {
    marginTop: theme.spacing(3)
  }
}));

const RejectedPage = () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <AppBar position="static" className={classes.appBar}>
        <Toolbar>
          <img src={cargoesLogo} alt="Cargoes Logo" style={{ height: 30, marginRight: 16 }} />
          <Typography variant="h6">e-Sign</Typography>
        </Toolbar>
      </AppBar>
      
      <Container className={classes.container}>
        <Paper className={classes.paper}>
          <CancelIcon className={classes.icon} />
          <Typography variant="h4" gutterBottom>
            Document Rejected
          </Typography>
          <Typography variant="body1" paragraph>
            The document has been rejected and all parties have been notified.
          </Typography>
          <Typography variant="body2" color="textSecondary">
            You can now close this window.
          </Typography>
        </Paper>
      </Container>
    </div>
  );
};

export default RejectedPage;